var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Page"},[_c('div',{ref:"myChartChina",staticStyle:{"width":"720px","height":"550px"},attrs:{"id":"myChartChina"}})])}
var staticRenderFns = []

export { render, staticRenderFns }